import React, { Component } from 'react';
import Banner from 'src/components/views/common/banners/pfs-banner-custom';
import { withI18n } from '@shopify/react-i18n';

type Props = {
  onDismiss: Function,
  featureName: string
};
class SearchSettingProcessingBanner extends Component<Props> {
  render() {
    const { i18n, syncDuration } = this.props;
    if (syncDuration <= 0) {
      return <></>;
    }
    return (
      <Banner
        name="searchSettingProcessingBanner"
        status="info"
        icon="process"
        allowDismiss={true}
        hasOutline={true}>
        <p>{i18n.translate('AdminHTML.SearchSettings.Banner.content')}</p>
      </Banner>
    );
  }
}
export default withI18n()(SearchSettingProcessingBanner);
